module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mdl-radio mdl-js-radio-mdl-js-ripple-effect",
    class: {
      'is-dirty': _vm.value, 'error': _vm.errors.any()
    },
    attrs: {
      "for": _vm.id
    }
  }, [_c('input', {
    staticClass: "mdl-radio_button",
    attrs: {
      "id": _vm.id,
      "type": "radio",
      "name": _vm.name,
      "data-vv-name": _vm.name,
      "data-vv-value-path": "value"
    },
    domProps: {
      "value": _vm.val,
      "checked": _vm.value === _vm.val
    },
    on: {
      "change": _vm.onChange
    }
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d9bff2c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/form/RadioButton.vue
// module id = 528
// module chunks = 1